import React, {
  createContext,
  useCallback,
  useContext,
  useReducer,
} from "react";

import api from "../Api";

export const CONSTANTS = {
  FETCH_BY_ID: "FETCH_BY_ID",
  SET_SPOTS_CACHE: "SET_SPOTS_CACHE",
};

const INITIAL_STATE = {
  spots: [],
  spotsCache: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case CONSTANTS.FETCH_BY_ID:
      return {
        ...state,
        spots: [...state.spots, action.spot],
      };
    case CONSTANTS.SET_SPOTS_CACHE:
      return {
        ...state,
        spotsCache: action.spotsCache,
      };
    default:
      return INITIAL_STATE;
  }
};

export const Context = createContext(INITIAL_STATE);

export const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  return (
    <Context.Provider value={{ dispatch, state }}>{children}</Context.Provider>
  );
};

export const useSpotsStore = () => {
  const { dispatch, state } = useContext(Context);

  const fetchById = useCallback(
    async (id) => {
      const response = await api.get(`/spots/${id}`);

      if (response?.spot) {
        const _spotsCache = [...state.spotsCache];

        if (_spotsCache.find((s) => s.id === response?.spot?.id)) {
          _spotsCache.splice(
            _spotsCache.findIndex((s) => s.id === response?.spot?.id),
            1,
            response?.spot,
          );
        } else {
          _spotsCache.push(response?.spot);
        }

        dispatch({
          type: CONSTANTS.SET_SPOTS_CACHE,
          spotsCache: _spotsCache,
        });

        dispatch({ type: CONSTANTS.FETCH_BY_ID, spot: response.spot });
      }

      return response?.spot;
    },
    [dispatch, state.spotsCache],
  );

  const updateExcelScheme = useCallback(
    async (id, data) => await api.put(`/spots/${id}/excelscheme`, data),
    [],
  );

  return {
    state,
    updateExcelScheme,
    fetchById,
  };
};
